__turbopack_context__.v({
  "accordion": "styles-module-scss-module__UsLM3q__accordion",
  "bold": "styles-module-scss-module__UsLM3q__bold",
  "highlight": "styles-module-scss-module__UsLM3q__highlight",
  "menuTypeMobile": "styles-module-scss-module__UsLM3q__menuTypeMobile",
  "navigation": "styles-module-scss-module__UsLM3q__navigation",
  "selected": "styles-module-scss-module__UsLM3q__selected",
  "subMenuChildren": "styles-module-scss-module__UsLM3q__subMenuChildren",
});
